import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {NgForm} from "@angular/forms";
import {Partner} from "../../../shared/interface/partner";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {PartnerService} from "../../../shared/services/partner.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {FilterService} from "../../../shared/services/filter.service";
import {Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {ActivatedRoute, Router} from "@angular/router";
import {takeUntil} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {AnalyticsService} from "../../../shared/services/analytics.service";

@Component({
  selector: 'app-report-partners',
  templateUrl: './report-partners.component.html',
  styleUrls: ['./report-partners.component.scss']
})
export class ReportPartnersComponent implements OnInit , OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;

  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private analyticsService: AnalyticsService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.parseFilters();
  }

  ngOnInit(): void {
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      recordId: 'string',
      legalForm: 'int',
      in$formOfBusiness: 'int[]',
      contains$fullName: 'string',
      contains$shortName: 'string',
      contains$nip: 'string',
      contains$regon: 'string',
      contains$krs: 'string',
      email: 'string',
      phone: 'string',
      contains$accountNumber: 'string',
      vatPayer: 'int',
      in$status: 'int[]',
      assetsRegional: 'string[]',
      lifeRegional: 'string[]',
      address: 'string',
      state: 'int',
      tags: 'int[]',
      verified: 'int',
      selfBilling: 'int',
      headers: 'array'
    }, filters);
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path,  this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: 10,
      ...this.filtersForm.value,
    })]);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: 10,
    }]);
  }

  downloadReport(): void {
    this.analyticsService.downloadReportPartners(this.filtersForm.value)
      .subscribe((response: Uuid) => {
        const dialogRef = this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

}
